import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './BackofficeSidebar.css';

// Import icons
import { 
  FaClipboardList,
  FaMoneyBillWave,
  FaCog,
  FaSearch,
  FaDatabase
} from 'react-icons/fa';

const BackofficeSidebar = () => {
  const location = useLocation();
  const { getCurrentUser } = useAuth();
  const currentUser = getCurrentUser();

  // Define sidebar links with appropriate icons
  const sidebarLinks = [
    { path: '/backoffice/leads', label: 'Applications', icon: <FaClipboardList size={18} /> },
    { path: '/backoffice/invoices', label: 'Invoices', icon: <FaMoneyBillWave size={18} /> },
    { path: '/backoffice/settings', label: 'Settings', icon: <FaCog size={18} /> },
  ];

  return (
    <div className="backoffice-sidebar">
      <div className="backoffice-sidebar-logo">
        <img src="/static/images/Wishfin-logo.png" alt="Wishfin" />
      </div>
      
      <div className="backoffice-sidebar-title">
        <h3>Backoffice Portal</h3>
      </div>
      
      <nav className="backoffice-sidebar-nav">
        <ul>
          {/* Main links */}
          {sidebarLinks.map((link) => (
            <li 
              key={link.path} 
              className={location.pathname.startsWith(link.path) ? 'active' : ''}
            >
              <Link to={link.path}>
                <span className="backoffice-sidebar-icon">{link.icon}</span>
                <span className="backoffice-sidebar-label">{link.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      
      <div className="backoffice-sidebar-user-status">
        <div className="backoffice-sidebar-status">
          <div className="status-indicator online"></div>
          <span>Active</span>
        </div>
      </div>
    </div>
  );
};

export default BackofficeSidebar;